import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#a)",
  fill: "#1F1F1F"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21.655 1h-3.322c-.674 0-1.25.508-1.364 1.204l-.532 3.248a.564.564 0 0 1-.547.483H4.245a2.21 2.21 0 0 0-1.768.902 2.44 2.44 0 0 0-.412 2.014l1.451 6.07c.363 1.533 1.677 2.61 3.185 2.61h7.812c1.62-.004 2.995-1.244 3.24-2.921l1.668-10.227a.564.564 0 0 1 .545-.483h1.69c.764 0 1.384-.65 1.384-1.45 0-.8-.62-1.45-1.384-1.45ZM3.898 21.091a1.899 1.899 0 1 0 3.798 0 1.899 1.899 0 0 0-3.798 0ZM13.494 21.091a1.899 1.899 0 1 0 3.798 0 1.899 1.899 0 0 0-3.798 0Z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M2 1h21v22H2z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }